import {createAction} from "redux-act";
import {IHelpState} from "modules/types";

export const getHelpContent = createAction<string>();
export const getFaqContent = createAction<string>();
export const setHelpContent = createAction<IHelpState>();
